import { connect } from 'react-redux';
import React, { useEffect } from 'react';
import { Routes as RouterRoutes, Route } from 'react-router-dom';
import { loadDigitalOrderDisplayDetails } from 'researcher/digital-orders/actions';
import DigitalTranslationsContainer from './components/DigitalTranslationsContainer';
// import DigitalTranslationsPaymentContainer from './components/DigitalTranslationsPaymentContainer';

export var Routes = function Routes(_ref) {
  var loadDigitalOrderDisplayDetails = _ref.loadDigitalOrderDisplayDetails;
  useEffect(function () {
    loadDigitalOrderDisplayDetails();
  }, []);
  return /*#__PURE__*/React.createElement(RouterRoutes, null, /*#__PURE__*/React.createElement(Route, {
    path: ":status?",
    element: /*#__PURE__*/React.createElement(DigitalTranslationsContainer, null)
  }));
};
var mapDispatchToProps = {
  loadDigitalOrderDisplayDetails: loadDigitalOrderDisplayDetails
};
export default connect(null, mapDispatchToProps)(Routes);